<template>
    <div id="finished_item_main" class="ui centered container segment">
        <div class="ui secondary menu">
            <div class="ui secondary center menu">
                <div class="item">
                    <select class="ui simple dropdown" v-model="filter._partner" @change="updatePage(1)">
                        <option :value="undefined">전체업체</option>
                        <option :value="x._id" v-for="x in getPartners()" :key="x._id">{{ x.name }}</option>
                    </select>
                </div>
                <div class="item">
                    <select class="ui simple dropdown" v-model="filter._center" @change="updatePage(1)">
                        <option :value="undefined">전체센터</option>
                        <option :value="x._id" v-for="x in getCenters()" :key="x._id">{{ x.name }}</option>
                    </select>
                </div>
                <div class="item">
                    <select class="ui simple dropdown" v-model="filter._worker" @change="updatePage(1)">
                        <option :value="undefined">전체기사</option>
                        <option :value="x._id" v-for="x in getWorkers(filter._center)" :key="x._id">{{ x.name }}</option>
                    </select>
                </div>
                <div class="item">
                    <div class="ui search selection dropdown" id="main_product_dropdown">
                        <input type="hidden">
                        <i class="dropdown icon"></i>
                        <div class="default text">상품</div>
                        <div class="menu">
                            <div class="item">전체상품</div>
                            <div class="item" v-for="p in products" :key="p._id">{{ p.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <button class="ui teal button" @click="download">다운로드</button>
                </div>
                <div class="item">
                    <button class="ui orange button" @click="updatePage(page)">새로고침</button>
                </div>
            </div>
        </div>
        <div class="ui secondary menu">
            <div class="ui secondary center menu">
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui calendar" id="calendar_start">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="취소날짜(부터)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui calendar" id="calendar_end">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="취소날짜(까지)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui input left icon">
                                <i class="user icon"></i>
                                <input type="text" placeholder="주문자" v-model="filter.orderer" @change="updatePage()">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui input left icon">
                                <i class="user icon"></i>
                                <input type="text" placeholder="수취인" v-model="filter.receiver" @change="updatePage()">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui input left icon">
                                <i class="file icon"></i>
                                <input type="text" placeholder="메모(설치유형)" v-model="filter.partnerMemo" @change="updatePage(1)">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="filter.isDelivery" @change="updatePage(1)">
                                <label>배송</label>
                            </div>
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="filter.isInstall" @change="updatePage(1)">
                                <label>설치</label>
                            </div>
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="filter.isExchange" @change="updatePage(1)">
                                <label>교환</label>
                            </div>
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="filter.isRecall" @change="updatePage(1)">
                                <label>회수</label>
                            </div>
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="filter.isAS" @change="updatePage(1)">
                                <label>AS</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrolling content">
            <table class="ui selectable striped celled compact table">
                <thead>
                    <tr>
                        <th class="collapsing">#</th>
                        <th class="collapsing">업체</th>
                        <th class="collapsing">발주날짜</th>
                        <th class="collapsing">취소날짜</th>
                        <th class="collapsing">주문자</th>
                        <th class="collapsing">상품명</th>
                        <th class="collapsing">수량</th>
                        <th class="collapsing">지역</th>
                        <th class="collapsing">담당센터</th>
                        <th class="collapsing">배송기사</th>
                        <th>메모(설치유형)</th>
                        <th>코멘트</th>
                        <th class="right collapsing"></th>
                    </tr>
                </thead>
                <tbody v-if="items.length > 0">
                    <tr v-for="(item, index) in items" :key="item._id">
                        <td class="collapsing">{{ ((page-1) * 50) + index + 1 }}</td>
                        <td class="collapsing">{{ item.partnerName }}</td>
                        <td class="collapsing">{{ item.confirmedAt ? new Date(item.confirmedAt).format("yyyy-MM-dd(KS)") : "" }}</td>
                        <td class="collapsing">{{ item.createdAt ? new Date(item.createdAt).format("yyyy-MM-dd(KS)") : "" }}</td>
                        <td>{{ item.orderer }}</td>
                        <td>{{ item.product }}</td>
                        <td class="collapsing">{{ item.count }}</td>
                        <td class="collapsing">{{ item.region1 + " " + item.region2 }}</td>
                        <td class="collapsing">{{ item.centerName }}</td>
                        <td class="collapsing">{{ item.workerName }}</td>
                        <td>{{ item.partnerMemo }}</td>
                        <td>{{ item.comment ? item.comment : item.reasonForCancel }}</td>
                        <td class="right collapsing">
                            <div class="ui small icon buttons">
                                <button :class="item == selected ? 'ui grey button' : 'ui basic button'" @click="openItemDetail(item)">
                                    <i class="file outline icon"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="ui pagination menu">
                <a class="icon item"><i class="left chevron icon"></i></a>
                <a :class="page === i ? 'active item' : 'item'" v-for="i in totalPages" :key="i" @click="onPageClick(i)">{{ i }}</a>
                <a class="icon item"><i class="right chevron icon"></i></a>
            </div>
        </div>
    </div>
</template>

<script>

const moment = require("moment");

export default {
    data: function() {
        return {
            page: 0, totalPages: 0, prevPage: 0, nextPage: 0, filter: 0, items: 0, selected: 0,
        }
    },
    created: function() {
        this.page = 1;
        this.totalPages = 1;
        this.prevPage = null;
        this.nextPage = null;
        this.filter = {
            isDelivery: true,
            isInstall: true,
            isExchange: true,
            isRecall: true,
            isAS: true,
        };
        this.items = [];
        
    },
    mounted: function() {
        this.updatePage(1);
        this.$ui.calendar_StartEnd("#calendar_start", "#calendar_end",
            (date, text) => { this.filter.dateStart = text; },
            (date, text) => { this.filter.dateEnd = text; this.updatePage(1); });
        this.$ui.dropdown("#main_product_dropdown", (text) => { this.filter.product = this.findProductName(text.toUpperCase()); this.updatePage(1); });
    },
    methods: {
        findProductName(productName) {
            for (var product of this.products) {
                if (product.name == productName) {
                    return product.name;
                }
            }
            return undefined;
        },
        updatePage(page) {
            if (this.filter.dateStart) { this.filter.dateStart = new Date(this.filter.dateStart); }
            if (this.filter.dateEnd) { this.filter.dateEnd = new Date(this.filter.dateEnd); }
            this.filter.status = this.constant.STATUS_CANCEL;
            this.$event.call("openLoading");
            this.$api.getFinishedItemList(page, this.filter, (resData) => {
                this.$event.call("closeLoading");
                this.items = resData.items;
                this.page = resData.page;
                this.totalPages = Math.min(resData.totalPages, 10);
                this.prevPage = resData.prevPage;
                this.nextPage = resData.nextPage;
            });
        },
        openItemDetail(item) {
            this.selected = item;
            this.$event.call("finishedItemDetail_open", item._id, () => this.updatePage(this.page));
        },
        download() {
            this.filter.status = this.constant.STATUS_CANCEL;
            this.$event.call("openLoading");
            console.log(this.filter);
            this.$api.getFinishedItems(this.filter, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else if (resData.items && resData.items.length > 0) {
                    this.$event.call("open_product_counter", resData.items);
                    this.$excel.downloadFinishedItem(this, resData.items, "취소건");
                }
            });
        },
        onPageClick(page) {
            this.updatePage(page);
        },
        onPrevPageClick() {
            if (this.prevPage) { this.updatePage(this.prevPage); }
        },
        onNextPageClick() {
            if (this.nextPage) { this.updatePage(this.nextPage); }
        },
        getPartners()
        {
            const array = [];
            for (const partner of this.partners)
            {
                if (!partner.isTerminated) array.push(partner);
            }
            return array;
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated) array.push(center);
            }
            return array;
        },
        getWorkers(_center)
        {
            const array = [];
            for (const worker of this.workers)
            {
                if (worker.position == "배송기사")
                {
                    if (!_center || worker._center == _center)
                    {
                        array.push(worker);
                    }
                }
            }
            return array;
        },
        getProducts(_partner)
        {
            const array = [];
            for (const product of this.products)
            {
                if (!_partner || product._partner == _partner)
                {
                    array.push(product);
                }
            }
            return array;
        },
    },
    computed: {
        isHeader: function() { return this.$store.getters.isHeader; },
        isPartner: function() { return this.$store.getters.isPartner; },
        isCenter: function() { return this.$store.getters.isCenter; },
        partners: function() { return this.$store.getters.partners; },
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
        products: function() { return this.$store.getters.products; },
        constant: function() { return this.$store.getters.constant; },
        constantNames: function() { return this.$store.getters.constantNames; },
    },
};
</script>

<style>
#finished_item_main {
    overflow: auto;
    min-width: 1500px;
    max-width: 1500px;
    min-height: 700px;
}

#finished_item_main .ui.secondary.menu .item {
    padding: 0;
}

#finished_item_main .ui.grid {
    padding-bottom: 10px;
}

#finished_item_main .ui.grid .ui.dropdown {
    margin-top: 3px;
}

#finished_item_main .ui.table {
    width: 100%;
    padding: 0;
    font-size: 12px;
}

#finished_item_main .ui.table td {
    max-width: 300px;
}

#finished_item_main .ui.text.menu {
    margin: 0;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/CanceledItemMain.vue